<template>
    <div>
        <div class="mb-3 mt-3">
            <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left ">Adjustments</label>
            <div>
                <select class="form-control" @change="setImgAdjustment" :value="adjustment">
                    <option value="contain">Contain</option>
                    <option value="cover">Cover</option>
                    <option value="stretch">Stretch</option>
                    <option value="original_size">Original Size</option>
                    <option value="tile">Tile</option>
                    <option value="burn_effect">Ken Burns Effect</option>
                </select>
            </div>
        </div> 
        <div class="mb-3">
            <label class=" block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left ">Image Orientation</label>
            <div class=" flex flex-1 space-x-1.5">
                <div @click="setActiveButton(1)" :class="`${activeButton !== 1 ? 'opacity-25' : ''} hover:opacity-100 cursor-pointer transition-opacity duration-150 
                                                    flex flex-1 items-center justify-center
                                    border border-gray-900 rounded
                                    p-1`">
                    <span class="text-lg font-extrabold">0</span>
                    <span class="text-lg">°</span>
                </div>
                <div @click="setActiveButton(2)" :class="`${activeButton !== 2 ? 'opacity-25' : ''}   hover:opacity-100 cursor-pointer transition-opacity duration-150 
                                                    flex flex-1 items-center justify-center
                                    border border-gray-900 rounded
                                    p-1 ml-2 `">
                    <span class="text-lg font-extrabold">90</span>
                    <span class="text-lg">°</span>
                </div>
                <div @click="setActiveButton(3)" :class="` ${activeButton !== 3 ? 'opacity-25' : ''}   hover:opacity-100 cursor-pointer transition-opacity duration-150 
                                                    flex flex-1 items-center justify-center
                                    border border-gray-900 rounded
                                    p-1 ml-2`">
                    <span class="text-lg font-extrabold">180</span>
                    <span class="text-lg">°</span>
                </div>
                <div @click="setActiveButton(4)" :class="` ${activeButton !== 4 ? 'opacity-25' : ''}  hover:opacity-100 cursor-pointer transition-opacity duration-150 
                                                    flex flex-1 items-center justify-center
                                                    border border-gray-900 rounded
                                                    p-1 ml-2`">
                    <span class="text-lg font-extrabold">270</span>
                    <span class="text-lg">°</span>
                </div>
            </div>
        </div>
        <div class="mb-3">
            <label
                class=" block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left ">Adjust</label>
            <div>
                <div class="d-flex align-items-center justify-content-center">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    Border Radius
                </label>
                <div class="flex-1">
                    <input type="range" min='0' max='500' step='1' :value="borderRadius"  @input="borderRadiusadd" class="form-control-range" />
                </div>
                <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{borderRadius}}</div>
            </div>

                <div class="sliderWrapper mt-2">
                    <div class="d-flex align-items-center justify-content-center">
                        <label
                            class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                            BRIGHTNESS
                        </label>
                        <div class="flex-1">
                            <input type="range" @input="setbrightness" :value="brightness / 2" min="0" max="100"
                                class="form-control-range" />
                        </div>
                        <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{ (brightness / 2) - 50 }}</div>
                    </div>
                </div>
                <div class="sliderWrapper mt-2">
                    <div class="d-flex align-items-center justify-content-center">
                        <label
                            class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                            Contrast
                        </label>
                        <div class="flex-1">
                            <input type="range" @input="setContrast" :value="contrast / 2" min="0" max="100"
                                class="form-control-range" />
                        </div>
                        <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{ (contrast / 2) - 50 }}</div>
                    </div>
                </div>
                <div class="sliderWrapper mt-2">
                    <div class="d-flex align-items-center justify-content-center">
                        <label
                            class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                            Saturation
                        </label>
                        <div class="flex-1">
                            <input type="range" @input="setSaturation" :value="saturation / 2" step='1' min="0" max="100"
                                class="form-control-range" />
                        </div>
                        <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{ (saturation / 2) - 50 }}</div>
                    </div>
                </div>
                <div class="sliderWrapper mt-2">
                    <div class="d-flex align-items-center justify-content-center">
                        <label
                            class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                            Transparency
                        </label>
                        <div class="flex-1">
                            <input type="range" @input="showObjectTransparency" :value="transparencyValue" min="0" max="100"
                                class="form-control-range" />
                        </div>
                        <div class="w-8 text-sm font-bold text-right text-gray-700 ml-2">{{ transparencyValue }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "ImagesSettings",
    data() {
        return {
            activeButton: 1,
            brightness: 50,
            contrast:50,
            saturation:50,
            borderRadius:0,
            transparencyValue:100,
            adjustment:'cover'
        }
    },
    computed: {
        getActiveObj() {
            return this.$store.getters.getActiveObjectprops
        },
    },
    watch:{
        getActiveObj :{
          handler(updatedValues) {
            
            // this.lineheight = updatedValues.lineHeight;
            this.borderRadius = updatedValues.borderRadius;
            this.brightness = updatedValues.brightness;
            this.contrast = updatedValues.contrast;
            this.saturation = updatedValues.saturation;
            this.adjustment = updatedValues.adjustment;
         
                
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        setActiveButton(value) {
            this.activeButton = value;
            this.$store.dispatch("setCurrentObjectProperties" , { rotate: value === 1 ? 0 : value === 2 ? 90 : value === 3 ? 180 : 270 });

        },
        showObjectTransparency(e) {

        let value = e.target.value;
        this.transparencyValue = value;

        this.$store.dispatch("setCurrentObjectProperties" , { opacity: value / 100 });

        },
        setbrightness(e) {

            this.brightness = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties", { brightness: e.target.value * 2 });

        },
        setContrast(e) {

            this.contrast = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties", { contrast: e.target.value * 2 });

        },
        setSaturation(e) {

            this.saturation = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties", { saturation: e.target.value * 2 });

        },
        borderRadiusadd(e){
            

            let value = e.target.value;
            this.borderRadius = value;
            if(this.getActiveObj.type != "text" ){
                this.$store.dispatch("setCurrentObjectProperties" , { borderRadius: value });

            }
            
        },
        setImgAdjustment(e){
            let value = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties", { adjustment: value });
        }
    }
}
</script>

<style scoped>
.tracking-widest {
    letter-spacing: .1em;
}

.uppercase {
    text-transform: uppercase;
}

.font-semibold {
    font-weight: 600;
}

.text-xs {
    font-size: .75rem;
    line-height: 1rem;
}

.text-left {
    text-align: left;
}

.block {
    display: block;
}

.mb-2 {
    margin-bottom: .5rem;
}

.flex-1 {
    flex: 1 1;
}

.flex {
    display: flex;
}

.duration-150 {
    transition-duration: .15s;
}

.transition-opacity {
    transition-duration: .15s;
    transition-property: opacity;
    transition-timing-function: cubic-bezier(.4, 0, .2, 1);
}

.p-1 {
    padding: .25rem;
}

.border-gray-900 {
    --tw-border-opacity: 1;
    border-color: rgb(33 36 41/var(--tw-border-opacity)) !important;
}

.border {
    border-width: 1.5px;
}

.rounded {
    border-radius: .25rem;
}

.justify-center {
    justify-content: center;
}

.items-center {
    align-items: center;
}

.cursor-pointer {
    cursor: pointer;
}

.font-extrabold {
    font-weight: 800;
}

.text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
}

.opacity-25 {
    opacity: .25;
}

.hover\:opacity-100:hover {
    opacity: 1;
}</style>